module.exports = __webpack_public_path__ + "static/media/alter_shape_passo0.822a5c43.png";